import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	serviceItem: {
		marginBottom: "15px",
	},

	serviceItemLast: {
		marginBottom: "0",
	},

	serviceHeader: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "flex-start",
		marginBottom: 8,
	},

	serviceName: {
		fontSize: "18px",
		fontWeight: "bold",
		color: "#333333",
		flex: "1",
		maxWidth: "70%",
		wordWrap: "break-word",
		lineHeight: "1.2",
	},

	servicePrice: {
		fontSize: "18px",
		fontWeight: "bold",
		color: "#333333",
		flexShrink: 0,
	},

	professionalName: {
		fontSize: 16,
		color: "#222",
		fontWeight: 600,
	},

	serviceDate: {
		fontSize: "16px",
		color: "#222",
	},

	serviceDuration: {
		fontSize: "16px",
		color: "#222",
	},

	priceType: {
		paddingLeft: 4,
		fontSize: "16px",
		color: "#222",
		fontStyle: "italic",
		color: "rgba(0,0,0,0.65)"
	},

	headerAvatar: {
		width: 56,
		height: 56,
		backgroundColor: "#8C1837",
	},

	uponConsultation: {
		fontSize: "16px",
		color: "#222",
		fontStyle: "italic",
		color: "rgba(0,0,0,0.65)"
	},
}));

export default useStyles;
